import { render } from "./CSATTableReport.vue?vue&type=template&id=71167b6e&scoped=true"
import script from "./CSATTableReport.vue?vue&type=script&lang=js"
export * from "./CSATTableReport.vue?vue&type=script&lang=js"

import "./CSATTableReport.vue?vue&type=style&index=0&id=71167b6e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71167b6e"]])

export default __exports__